import {
  ImportRowStatus,
  resolveImportRowStatus
} from '../../../../helpers/advertiserBrandImport'

export type ReviewRow = {
  id: string
  gtin: string
  brand: string
  name: string
  image_url: string | null
  current_brand: string | null
  status: ImportRowStatus
  code?: AdvertiserBrandImportErrorCode
}

/**
 * O BFF devolve em `preview` só as linhas que passaram no parse; as demais
 * vêm em `errors`, numeradas pela linha do arquivo, e entram na tabela como
 * linhas próprias (só o EAN digitado sobrevive ao parse).
 */
export const buildReviewRows = (
  preview: AdvertiserBrandImportPreviewResponse,
  productNotFoundLabel: string
): ReviewRow[] => {
  const factRows = preview.preview.map<ReviewRow>((row, index) => ({
    id: `row-${index}`,
    gtin: row.gtin,
    brand: row.brand,
    image_url: row.image_url ?? null,
    current_brand: row.current_brand ?? null,
    status: resolveImportRowStatus(row, false),
    // dizer "não encontrado" só quando o catálogo já respondeu que não tem
    name:
      row.product_name ||
      (row.in_publisher_catalog === false ? productNotFoundLabel : '—')
  }))

  const errorRows = preview.errors.map<ReviewRow>(error => ({
    id: `error-${error.row}`,
    gtin: error.value ?? '',
    brand: '',
    image_url: null,
    current_brand: null,
    status: 'error',
    code: error.code,
    name: '—'
  }))

  return [...factRows, ...errorRows]
}

/** O rótulo é o desfecho da linha; sem os fatos do dry-run, "não verificado". */
export const statusLabelKey = (
  status: ImportRowStatus,
  errorCode?: AdvertiserBrandImportErrorCode
) => {
  if (status === 'error') {
    return `rm:advertiserProducts.import.errors.${
      errorCode ?? 'EAN_NOT_IN_CATALOG'
    }` as const
  }

  return `rm:advertiserProducts.import.review.status.${status}` as const
}
